import { Configs } from '../../data';
import { ActionBrick, BrickContext, Transaction, registerBrick } from 'olympe';

type Inputs = [entry: object];

type Outputs = [forwardEvent: () => void];

export default class UpdateStreamData extends ActionBrick {
  async update($: BrickContext, [entry]: Inputs, [forwardEvent]: Outputs) {
    const streamData = await Configs.find('STREAM_DATA', $);
    const persistedData = JSON.parse(streamData.getValue());

    Transaction.from($)
      .update(
        streamData,
        Configs.valueProp,
        JSON.stringify([...persistedData, entry])
      )
      .execute();

    forwardEvent();
  }
}

registerBrick('01899b6eed55c388a3a3', UpdateStreamData);
